module.exports = __webpack_public_path__ + "media/images/flags/32/Nigeria-76ae3c609bb20510c00d3607b7de3165.png";